import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const PaymentServices = {
  getPaymentHistories,
  getPaymentHistoriDownload,
  getMutasiSaldo,
  getMutasiSaldoDownload,
  tiketdeposit,
  getPaymentmethod,
  getInvoiceCC
}

function getInvoiceCC (postdata) {
  return fetch(API_URL + '/api/v1/payment/invoice', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function tiketdeposit (postdata) {
  return fetch(API_URL + '/api/v1/payment/tiket', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getPaymentmethod () {
  return fetch(API_URL + '/api/v1/payment/method', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getMutasiSaldo (opt) {
  console.log(opt)
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('mutasisaldosort')
    } else {
      localStorage.setItem('mutasisaldosort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/v1/payment/mutasisaldo?search=' + opt.search + '&statustrx=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getMutasiSaldoDownload (opt) {
  console.log(opt)
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('mutasisaldosort')
    } else {
      localStorage.setItem('mutasisaldosort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/v1/payment/mutasisaldo/download?search=' + opt.search + '&statustrx=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getPaymentHistories (opt) {
  console.log(opt)
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('payhistorisort')
    } else {
      localStorage.setItem('payhistorisort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/v1/payment/histories?search=' + opt.search + '&statustrx=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getPaymentHistoriDownload (opt) {
  console.log(opt)
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('payhistorisort')
    } else {
      localStorage.setItem('payhistorisort', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }

  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  return fetch(API_URL + '/api/v1/payment/histories/download?search=' + opt.search + '&statustrx=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
